import { api, API, formatApiError } from "@/lib/api";
import { toast } from "sonner";

// Module-level callback registered by the singleton <DownloadModal /> mounted
// near the app root. We use a registration pattern (rather than props) so any
// page can trigger an export without owning the modal state.
let openModalImpl = null;
export function registerDownloadModal(fn) {
  openModalImpl = fn;
}

/** Request a one-time download token from the backend and open the
 *  <DownloadModal /> with the real download URL. The user clicks the visible
 *  link inside the modal — that's a plain `<a href>` so the browser handles
 *  it natively. Works in every browser, every extension config, every AV.
 *
 *  Returns {ok, count} so callers can refresh local UI state.
 */
export async function downloadExport(mode = "new") {
  try {
    const { data } = await api.post("/exports/request", { mode });
    const url = `${API}/exports/download/${encodeURIComponent(data.token)}`;
    const ts = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
    const filename = `approved-${mode}-${ts}.xlsx`;
    if (!openModalImpl) {
      // Fallback if the modal hasn't mounted yet (shouldn't happen in
      // production — App.js renders it at startup). Show a toast with a
      // clickable URL.
      toast.message("Download ready", {
        description: url,
        duration: 30000,
      });
      return { ok: true, count: data.count };
    }
    openModalImpl({ url, count: data.count, mode, filename });
    return { ok: true, count: data.count };
  } catch (e) {
    const detail = e?.response?.data?.detail;
    toast.error(formatApiError(detail) || e?.message || "Export failed");
    return { ok: false };
  }
}
